// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Archivo_Narrow_217741', '__Archivo_Narrow_Fallback_217741', Helvetica Neue, Arial, sans-serif","fontStyle":"normal"},"className":"__className_217741"};